
export default {
  props: {
    stepName: {
      type: String,
      required: true,
    },
  },
  inject: ['steppersState'],
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppSteppers/components/AppSteppersPane.vue